module.exports = "/_next/static/images/bda0653f6f9f69ca471c312ba49c9d90-bill-close_day.png.webp";